import React from 'react';
import { Helmet } from 'react-helmet';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';

function Home() {
  const products = [
    {
      id: 1,
      name: 'Premium Wandverkleidung',
      description: 'Hochwertige Wandverkleidung aus edlen Materialien für anspruchsvolle Innenräume. Perfekte Oberflächenbearbeitung mit langlebiger Schutzschicht.',
      price: 1299.99,
      image: '/images/1.jpg'
    },
    {
      id: 2,
      name: 'Luxus Bodenbeschichtung',
      description: 'Professionelle Bodenbeschichtung mit hervorragender Haltbarkeit und elegantem Finish. Ideal für gewerbliche und private Bereiche.',
      price: 1899.99,
      image: '/images/2.jpg'
    },
    {
      id: 3,
      name: 'Designer Deckenverkleidung',
      description: 'Exklusive Deckenverkleidung mit modernster Technik und zeitlosem Design. Schalldämmend und wärmeregulierend.',
      price: 1599.99,
      image: '/images/3.jpg'
    },
    {
      id: 4,
      name: 'Spezial Fassadenlack',
      description: 'Wetterbeständiger Fassadenlack mit UV-Schutz und selbstreinigender Oberfläche. Für langanhaltende Farbbrillanz.',
      price: 899.99,
      image: '/images/4.jpg'
    },
    {
      id: 5,
      name: 'Premium Holzschutz',
      description: 'Ökologischer Holzschutz mit Tiefenwirkung für Innen- und Außenbereiche. Schützt vor Feuchtigkeit und Schädlingen.',
      price: 749.99,
      image: '/images/5.jpg'
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Lackfertighaus - Premium Ausbauarbeiten und Finishing-Lösungen</title>
        <meta name="description" content="Entdecken Sie hochwertige Ausbauarbeiten und professionelle Finishing-Lösungen von Lackfertighaus. Qualität und Handwerkskunst seit 2010." />
        <meta property="og:title" content="Lackfertighaus - Premium Ausbauarbeiten" />
        <meta property="og:description" content="Hochwertige Finishing-Arbeiten und Handwerkskunst für Ihr Zuhause" />
      
        <link rel="canonical" href="https://lackfertighaus.com" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Store",
            "name": "Lackfertighaus",
            "image": "https://lackfertighaus.com/images/logo.jpg",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Karlplatz 5c",
              "addressLocality": "Elsdorf",
              "postalCode": "74737",
              "addressCountry": "DE"
            },
            "telephone": "+493455716202"
          })}
        </script>
      </Helmet>

      <section className="hero-section">
        <div className="hero-content">
          <h1>Willkommen bei Lackfertighaus</h1>
          <p>
            Ihre Experten für professionelle Ausbauarbeiten und erstklassige Finishing-Lösungen. 
            Wir verbinden traditionelle Handwerkskunst mit modernster Technologie für perfekte Ergebnisse.
          </p>
        </div>
      </section>

      <section className="features-section">
        <div className="features-container">
          <h2>Unsere Stärken</h2>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><FaStar /></div>
              <h3>Erstklassige Qualität</h3>
              <p>
                Wir verwenden ausschließlich hochwertige Materialien und moderne Technologien, 
                um langlebige und ästhetisch ansprechende Ergebnisse zu garantieren.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><FaHeart /></div>
              <h3>Leidenschaft für Details</h3>
              <p>
                Jedes Projekt wird mit größter Sorgfalt und Präzision ausgeführt. 
                Unsere Handwerker legen Wert auf perfekte Oberflächenbearbeitung.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><FaShoppingCart /></div>
              <h3>Umfassende Lösungen</h3>
              <p>
                Von der Beratung über die Materialauswahl bis zur finalen Umsetzung - 
                wir bieten Ihnen komplette Finishing-Lösungen aus einer Hand.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><FaHome /></div>
              <h3>Nachhaltige Werte</h3>
              <p>
                Umweltfreundliche Materialien und ressourcenschonende Verfahren stehen 
                im Mittelpunkt unserer Arbeit für eine nachhaltige Zukunft.
              </p>
            </div>
          </div>

          <div className="stats-container">
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Zufriedene Kunden</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">15</div>
              <div className="stat-label">Jahre Erfahrung</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100+</div>
              <div className="stat-label">Abgeschlossene Projekte</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5</div>
              <div className="stat-label">Premium Produkte</div>
            </div>
          </div>

          <div className="cta-section">
            <h3>Bereit für Ihr nächstes Projekt?</h3>
            <p>
              Kontaktieren Sie uns noch heute und lassen Sie sich von unseren Experten beraten. 
              Gemeinsam verwirklichen wir Ihre Vision von perfekten Oberflächen und professionellem Finish.
            </p>
          </div>
        </div>
      </section>

      <section className="about-text-section">
        <div className="about-text-container">
          <h2>Unsere Produkte und Dienstleistungen</h2>
          
          <div className="about-text-content">
            <h3>Exzellenz in jedem Detail</h3>
            
            <p>
              Seit 2010 steht Lackfertighaus für höchste Qualität in der Ausbau- und Finishing-Branche. 
              Unser Unternehmen hat sich auf die Bereitstellung erstklassiger Lösungen für Wand-, Boden- und 
              Deckenverkleidungen sowie professionelle Beschichtungssysteme spezialisiert. Jedes unserer Produkte 
              wird nach strengsten Qualitätsstandards entwickelt und getestet, um Ihnen langlebige und 
              ästhetisch perfekte Ergebnisse zu garantieren.
            </p>

            <p>
              Unsere Produktpalette umfasst innovative Materialien, die nicht nur durch ihre Optik überzeugen, 
              sondern auch durch ihre technischen Eigenschaften. Von wetterbeständigen Fassadenlacken über 
              schalldämmende Deckenverkleidungen bis hin zu selbstreinigenden Oberflächen - wir bieten Lösungen 
              für jeden Anspruch. Alle unsere Produkte werden in Deutschland entwickelt und entsprechen den 
              höchsten europäischen Standards für Sicherheit und Umweltschutz.
            </p>

            <h3>Qualität und Herkunft</h3>
            
            <p>
              Wir arbeiten ausschließlich mit renommierten deutschen und europäischen Herstellern zusammen, 
              die unsere hohen Anforderungen an Qualität und Nachhaltigkeit teilen. Unsere Materialien werden 
              unter Verwendung modernster Produktionstechnologien hergestellt und unterliegen kontinuierlichen 
              Qualitätskontrollen. Dies garantiert nicht nur eine gleichbleibend hohe Produktqualität, sondern 
              auch die Einhaltung aller relevanten Umwelt- und Gesundheitsstandards.
            </p>

            <ul>
              <li>Zertifizierte Materialien nach DIN- und ISO-Normen</li>
              <li>Umweltfreundliche Produktionsverfahren ohne schädliche Emissionen</li>
              <li>Langlebige Produkte mit bis zu 15 Jahren Garantie</li>
              <li>Regelmäßige Qualitätsprüfungen durch unabhängige Institute</li>
            </ul>

            <h3>Warum Lackfertighaus wählen?</h3>
            
            <p>
              Die Wahl von Lackfertighaus bedeutet die Entscheidung für Qualität, Zuverlässigkeit und 
              exzellenten Service. Unser erfahrenes Team aus Fachberatern und Handwerkern begleitet Sie 
              von der ersten Idee bis zur finalen Umsetzung. Wir verstehen, dass jedes Projekt einzigartig ist, 
              und bieten daher maßgeschneiderte Lösungen, die genau auf Ihre Bedürfnisse abgestimmt sind. 
              Mit über 500 zufriedenen Kunden und 15 Jahren Erfahrung haben wir uns als verlässlicher Partner 
              in der Branche etabliert.
            </p>

            <p>
              Unsere Firmengeschichte begann 2010 mit der Vision, traditionelle Handwerkskunst mit innovativen 
              Technologien zu verbinden. Was als kleines Familienunternehmen begann, ist heute ein führender 
              Anbieter für Premium-Finishing-Lösungen in Deutschland. Unser Erfolg basiert auf unserem 
              Engagement für Qualität, unserer Leidenschaft für Details und unserem unermüdlichen Streben 
              nach Kundenzufriedenheit. Bei Lackfertighaus erhalten Sie nicht nur Produkte, sondern umfassende 
              Lösungen, die Ihre Erwartungen übertreffen werden.
            </p>
          </div>
        </div>
      </section>

      <section className="products-section">
        <div className="products-container">
          <h2>Unsere Premium-Produkte</h2>
          <div className="products-grid">
            {products.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;